module.exports = __webpack_public_path__ + "assets/images/02_9c67d1762b27f0988240873c98ae9e27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/02.png
// module id = 262
// module chunks = 0